/**
 * @generated SignedSource<<43099b881320694e8dfa144e7d030fd0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useUpdateCommentInCacheFragment$data = {
  readonly author: {
    readonly __typename: string;
    readonly accountId?: string | null | undefined;
    readonly displayName: string | null | undefined;
    readonly permissionType: SitePermissionType | null | undefined;
    readonly profilePicture: {
      readonly path: string;
    } | null | undefined;
    readonly type: string | null | undefined;
  };
  readonly body: {
    readonly value: string;
  };
  readonly container: {
    readonly id: string | null | undefined;
  };
  readonly contentStatus: string;
  readonly contributors: ReadonlyArray<{
    readonly __typename: string;
    readonly accountId?: string | null | undefined;
    readonly displayName: string | null | undefined;
    readonly profilePicture: {
      readonly path: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly createdAt: {
    readonly value: string;
  };
  readonly createdAtNonLocalized: string;
  readonly id: string;
  readonly links: {
    readonly editui: string | null | undefined;
    readonly webui: string | null | undefined;
  };
  readonly location: {
    readonly __typename: string;
    readonly commentResolveProperties?: {
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null | undefined;
      readonly resolvedTime: AGG$Long | null | undefined;
      readonly resolvedUser: string | null | undefined;
    } | null | undefined;
    readonly inlineMarkerRef?: string | null | undefined;
    readonly inlineResolveProperties?: {
      readonly isDangling: boolean;
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null | undefined;
      readonly resolvedTime: AGG$Long | null | undefined;
      readonly resolvedUser: string | null | undefined;
    } | null | undefined;
    readonly inlineText?: string | null | undefined;
    readonly type: string;
  };
  readonly parentId: string | null | undefined;
  readonly permissions: {
    readonly isEditable: boolean;
    readonly isRemovable: boolean;
    readonly isResolvable: boolean;
  };
  readonly replies: ReadonlyArray<{
    readonly author: {
      readonly __typename: string;
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly permissionType: SitePermissionType | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    };
    readonly body: {
      readonly value: string;
    };
    readonly contentStatus: string;
    readonly contributors: ReadonlyArray<{
      readonly __typename: string;
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null | undefined;
      readonly webui: string | null | undefined;
    };
    readonly location: {
      readonly __typename: string;
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineMarkerRef?: string | null | undefined;
      readonly inlineResolveProperties?: {
        readonly isDangling: boolean;
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineText?: string | null | undefined;
      readonly type: string;
    };
    readonly parentId: string | null | undefined;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly version: {
      readonly by: {
        readonly __typename: string;
        readonly displayName: string | null | undefined;
      } | null | undefined;
      readonly number: number | null | undefined;
      readonly when: string | null | undefined;
    };
  } | null | undefined>;
  readonly version: {
    readonly by: {
      readonly __typename: string;
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly friendlyWhen: string | null | undefined;
    readonly number: number | null | undefined;
    readonly when: string | null | undefined;
  };
  readonly " $fragmentType": "useUpdateCommentInCacheFragment";
};
export type useUpdateCommentInCacheFragment$key = {
  readonly " $data"?: useUpdateCommentInCacheFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateCommentInCacheFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v3 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v4 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v8 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v9 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v10 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v7/*: any*/)
},
v11 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v12 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editui"
    },
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v14 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v15 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v16 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v17 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "commentResolveProperties",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/)
          ]
        }
      ],
      "type": "FooterComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "inlineMarkerRef"
        },
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "inlineResolveProperties",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isDangling"
            },
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "inlineText"
        }
      ],
      "type": "InlineComment"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v19 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v20 = {
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v4/*: any*/),
    (v6/*: any*/)
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "number"
},
v22 = {
  "kind": "ScalarField",
  "name": "when"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useUpdateCommentInCacheFragment",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/)
      ]
    },
    (v8/*: any*/),
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "container",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    {
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "replies",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v6/*: any*/),
            (v4/*: any*/)
          ]
        },
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "by",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/)
              ]
            },
            (v21/*: any*/),
            (v22/*: any*/)
          ]
        }
      ]
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "by",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v5/*: any*/),
            (v2/*: any*/),
            (v6/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "friendlyWhen"
        },
        (v21/*: any*/),
        (v22/*: any*/)
      ]
    }
  ],
  "type": "Comment"
};
})();

(node as any).hash = "3eaa0227f14e77a83748a865f02fa321";

export default node;
